export default class ServerException extends Error {

    constructor(message, code) {
        super();
        this.code = code;
        this.message = message;
    }

}


// WEBPACK FOOTER //
// ./web/src/components/services/ServerException.jsx